import * as React from 'react';

const AlignLeft = (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 1V19H2.2V1H1ZM14.2 4.6H4.6V9.4H14.2V4.6ZM19 10.6H4.6V15.4H19V10.6Z" fill="currentColor"/>
  </svg>
);

export default AlignLeft;
